import axios from "axios";
import TokenService from "../../services/TokenService";
import router from "../../router";
import { getLanguageFromLocalStorage } from "@/utils/pureFunctions.js";
import { decryptInterceptor } from "@/utils/decryptInterceptor";

export let baseURL = process.env["VUE_APP_API_BASE_URL"];
baseURL += "/api";
export let baseURLSocket = process.env["VUE_APP_API_BASE_URL"];
export const http = axios.create({
  baseURL,
});
export let baseURLMDC = process.env["VUE_APP_MDC_FILE_URL"];
baseURLMDC += "/api";
export const httpmdc = axios.create({
  baseURL: baseURLMDC,
});
export let baseURLMDConstruction = process.env["VUE_APP_MDF_CONSTRUCTION_URL"];
export const httpmdconstruction = axios.create({
  baseURL: baseURLMDConstruction,
});

function setConfiguration(provider) {
  provider.interceptors.request.use(
    (config) => {
      let token = TokenService.getToken();
      if (token) {
        config.headers["act"] = encodeURIComponent(token);
      }
      config.headers["Accept"] = "application/json";
      // config.headers["Content-Type"] = "application/json";
      config.headers["translate"] = "off";
      config.headers["lang"] = getLanguageFromLocalStorage("lang", "uz");
      config.headers["log"] = "true";
      return config;
    },
    (error) => Promise.reject(error)
  );
  provider.interceptors.response.use(
    (res) => {
      return decryptInterceptor(res);
    },
    (error) => {
      if (error.response && error.response.status === 401) {
        // store.commit("clearUserData");
        router.push({ name: "login" }).then();
      }
      return Promise.reject(error);
    }
  );
}

setConfiguration(http);
setConfiguration(httpmdc);
setConfiguration(httpmdconstruction);

export default http;
